import { Spin } from "antd";
import { applicationSelectionColour } from "./MainLayout/MainHeader";

function LoadingSpinner() {
    return <div style={{ display: 'flex', alignItems: 'center', textAlign: "center", minHeight: '75vh', justifyContent: 'center', height: '100%' }}>
        <div>
            <Spin size='large' />
            <div style={{ fontSize: 'xx-large', fontWeight: '350', color: applicationSelectionColour }}>
                Loading...
            </div>
        </div>
    </div>
}

export default LoadingSpinner;
